import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { IThreat } from '../../../../shared/models/threat';
import { ThreatService } from '../../../../shared/services/threat.service';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'threat-objectives-edit',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LucideAngularModule,
    NoEmojiDirective
  ],
  templateUrl: './threat-objectives-edit.component.html',
  styleUrl: './threat-objectives-edit.component.css'
})
export class ThreatObjectivesEditComponent implements OnInit{
  icons = Icons;
  threatObjectivesForm: FormGroup = new FormGroup({});

  loading: boolean = false;
  
  @Input() threatToEdit: any | null = null;

  @Output() onSave = new EventEmitter<any>;
  @Output() onClose = new EventEmitter<void>;

  constructor( private threatService: ThreatService ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['threatToEdit'] && this.threatToEdit) {
      this.initializeForm(); 
    }
  }

  private initializeForm(): void {
    this.threatObjectivesForm = new FormGroup({
      goal_before_description: new FormControl(this.threatToEdit.goals[0]?.goal_description || '', Validators.required),
      goal_before_objective: new FormControl(this.threatToEdit?.goals[0]?.objective || '', Validators.required),
      goal_during_description: new FormControl(this.threatToEdit?.goals[1]?.goal_description || '', Validators.required),
      goal_during_objective: new FormControl(this.threatToEdit?.goals[1]?.objective || '', Validators.required),
      goal_after_description: new FormControl(this.threatToEdit?.goals[2]?.goal_description || '', Validators.required),
      goal_after_objective: new FormControl(this.threatToEdit?.goals[2]?.objective || '', Validators.required)
    });
  }

  onSubmit(): void {
    if (this.threatObjectivesForm.valid && this.threatToEdit) {
      this.loading = true;
      const formValue = this.threatObjectivesForm.value;
      const data = [
        {
          goal_type: 1,
          goal_description: formValue.goal_before_description,
          objective: formValue.goal_before_objective
        },
        {
          goal_type: 2,
          goal_description: formValue.goal_during_description,
          objective: formValue.goal_during_objective
        },
        {
          goal_type: 3,
          goal_description: formValue.goal_after_description,
          objective: formValue.goal_after_objective
        }
      ];
      this.threatService.editThreatGoals(this.threatToEdit.id, {goals: data}).subscribe({
        next: (response) => {
          this.loading = false;
          if (!response.has_error) {
            this.onSave.emit({ type: 'success', message: 'This occurred after updating threat/hazard goals and objectives.' });
          }
          console.log(response);
        },
        error: (error) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: error.message });
        }
      })
    }
  }
  
  closeModal(): void {
    this.onClose.emit();
  }
}
